import { render } from "./SuggestPanel.vue?vue&type=template&id=076a85fe&ts=true"
import script from "./SuggestPanel.vue?vue&type=script&lang=ts"
export * from "./SuggestPanel.vue?vue&type=script&lang=ts"

import "./SuggestPanel.vue?vue&type=style&index=0&id=076a85fe&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__